import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "./App.css";

// Page Imports
import Homepage from "./pages/Homepage";
import LifeAtCampus from "./pages/LifeAtCampus";
import ProgramsPage from "./pages/ProgramsPage";
import SummerProgram from "./pages/SummerProgram";
import CrashProgram from "./pages/CrashProgram";
import Scholarships from "./pages/Scholarships";
import FeesCalculator from "./pages/FeesCalculator";
import ProgramDetail from "./pages/ProgramDetail";
import GraduateProgramDetails from "./pages/GraduateProgramDetails";
import AdmissionPolicy from "./pages/AdmissionPolicy";
import AdmissionProcedure from "./pages/AdmissionProcedure";
import CampusTour from "./pages/CampusTour";
import FeeStructure from "./pages/FeeStructure";
import ImportantDates from "./pages/ImportantDates";
import AdmissionSchedule from "./pages/AdmissionSchedule";
import ChatbotWidget from "./components/ChatbotWidget";

// 1. Professional Page Wrapper for consistent transitions
const PageWrapper = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }} // Starts slightly lower and invisible
      animate={{ opacity: 1, y: 0 }}   // Slides up and fades in
      exit={{ opacity: 0, y: -10 }}    // Slides up and fades out
      transition={{ duration: 0.4, ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  );
};

// 2. Scroll Fix: Ensures new page starts at the top
const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function AnimatedRoutes() {
  const location = useLocation();

  return (
    // mode="wait" ensures the old page finishes exiting before the new one enters
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><Homepage /></PageWrapper>} />
        <Route path="/fees-calculator" element={<PageWrapper><FeesCalculator /></PageWrapper>} />
        <Route path="/life-at-campus" element={<PageWrapper><LifeAtCampus /></PageWrapper>} />
        <Route path="/programs" element={<PageWrapper><ProgramsPage /></PageWrapper>} />
        <Route path="/summer-program-details" element={<PageWrapper><SummerProgram /></PageWrapper>} />
        <Route path="/crash-program-details" element={<PageWrapper><CrashProgram /></PageWrapper>} />
        <Route path="/scholarships" element={<PageWrapper><Scholarships /></PageWrapper>} />
        <Route path="/admission-policy" element={<PageWrapper><AdmissionPolicy /></PageWrapper>} />
        <Route path="/admission-procedure" element={<PageWrapper><AdmissionProcedure /></PageWrapper>} />
        <Route path="/campus-tour" element={<PageWrapper><CampusTour /></PageWrapper>} />
        <Route path="/fee-structure" element={<PageWrapper><FeeStructure /></PageWrapper>} />
        <Route path="/important-dates" element={<PageWrapper><ImportantDates /></PageWrapper>} />
        <Route path="/admission-schedule" element={<PageWrapper><AdmissionSchedule /></PageWrapper>} />
        
        <Route path="/program-details/:programId" element={<PageWrapper><ProgramDetail /></PageWrapper>} />
        <Route path="/graduate-program-details/:programId" element={<PageWrapper><GraduateProgramDetails /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
}



function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-container">
        <AnimatedRoutes />
        <ChatbotWidget />
      </div>
    </Router>
  );
}

export default App;